module.exports = __webpack_public_path__ + "img/ruanjian_tuyi.c8546250.png";